import { TwButton as BasicTwButton, TwButtonProps } from '@tw/tw-components-rn';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import React, { useState } from 'react';

interface BasicTwButtonProps extends TwButtonProps {
  useLoader?: boolean;
  onPress?: () => Promise<void>;
}

export const TwButton: React.FC<BasicTwButtonProps> = (props) => {
  const { useLoader = true, onPress, ...restProps } = props;

  const [loading, setLoading] = useState(props.isLoading);

  const handleButtonClick = async () => {
    if (useLoader) {
      setLoading(true);
      try {
        await onPress();
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    } else {
      onPress();
    }
  };

  return (
    <BasicTwButton {...restProps} isLoading={useLoader ? loading : props.isLoading} onPress={handleButtonClick}>
      {props.children}
    </BasicTwButton>
  );
};
